import React, { useContext, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FiCheck, FiX } from "react-icons/fi";
import { CartContext } from "./CartContext";
import "../css/paysuccess.css";

function PaySuccess() {
  const [params] = useSearchParams();
  const success = params.get("state") !== "cancel";
  const { clearCart } = useContext(CartContext);
  useEffect(() => { if (success) clearCart(); }, [success, clearCart]);
  return <main className="success-page"><div><span>{success ? <FiCheck /> : <FiX />}</span><p className="eyebrow">{success ? "ORDER CONFIRMED" : "PAYMENT CANCELLED"}</p><h1>{success ? "Thank you for your order" : "Your payment was not completed"}</h1><p>{success ? "Your order is being carefully prepared. A confirmation will be sent to your email address." : "No charge was made. Your basket is still available whenever you are ready."}</p><Link to={success ? "/shop" : "/checkout"}>{success ? "CONTINUE SHOPPING" : "RETURN TO CHECKOUT"}</Link></div></main>;
}
export default PaySuccess;
